import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { TableCell, TableRow, TableFooter } from '@mui/material'

import { getFormatNumber } from '@/utils'
import { ApplicationState } from '@/state/root.models'

const ReportsTableFooterComponent = () => {
  const { t } = useTranslation()

  const { globalReports, filters } = useSelector(
    ({ reports }: ApplicationState) => reports,
  )

  let summaryData = globalReports[0]

  const totalRtp =
    (Number(summaryData.totalWinsPlayers) /
      Number(summaryData.totalBetsPlayers)) *
    100

  return (
    <TableFooter>
      <TableRow sx={{ td: { fontSize: '16px', fontWeight: 700 } }}>
        <TableCell>{t('labels.total')}</TableCell>
        {filters.reportType !== '6' && (
          <TableCell>{summaryData.totalRoundsPlayers}</TableCell>
        )}
        <TableCell>
          {getFormatNumber(
            Number(summaryData.totalBetsPlayers),
            summaryData.currency,
          )}
        </TableCell>
        <TableCell>
          {getFormatNumber(
            Number(summaryData.totalWinsPlayers),
            summaryData.currency,
          )}
        </TableCell>
        <TableCell>
          {getFormatNumber(
            Number(summaryData.totalgameWinPlayers),
            summaryData.currency,
          )}
        </TableCell>
        <TableCell>{totalRtp.toFixed(2)}%</TableCell>
        {/* {filters.reportType === '5' && (
          <TableCell>{summaryData.totalBonus}</TableCell>
        )} */}
      </TableRow>
    </TableFooter>
  )
}

export default ReportsTableFooterComponent
